import React, { useState } from "react";
import { colors } from "../../../../../../../themes/Colors";
import BaseButtons from "../../../../../base-buttons/BaseButtons";

const DropDownBase = ({
  display,
  width,
  height,
  backgroundColor,
  borderRadius,
  data,
  optionHeight,
  setSelected,
  setClose,
  backgroundColorButton,
}) => {
  const [hover, setHover] = useState(null);
  return (
    <div
      style={{
        width: width,
        height: display ? height : 0,
        backgroundColor: backgroundColor,
        borderRadius: borderRadius,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        overflow: "hidden",
        // borderStyle: "solid",
        // borderWidth: display ? 2 : 0,
        // borderColor: colors.greenDark,
        transition: "all 0.1s",
      }}
    >
      {data
        ? data.map((item, index) => {
            return (
              <div
                onMouseOver={() => setHover(index)}
                onMouseOut={() => setHover(null)}
                onClick={() => {
                  setSelected(item);
                  setClose(false);
                }}
                key={index}
                style={{
                  width: "100%",
                  height: optionHeight,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: 14,
                  marginTop: 5,
                }}
              >
                <BaseButtons
                  label={item}
                  height={40}
                  borderRadius={8}
                  width={"90%"}
                  backgroundColor={
                    item === "MANAGE" ? colors.orangeDark : colors.white
                  }
                  color={item === "MANAGE" ? colors.white : colors.greenDark}
                />
              </div>
            );
          })
        : null}
      <div style={{ minHeight: 10 }} />
    </div>
  );
};

export default DropDownBase;
